import InfoBoxToolbarView from "./InfoBoxToolbarView.vue";
import InfoBoxNode from "./InfoBoxNode";

export default class InfoBox {

    constructor() {
        this.toolbarView = InfoBoxToolbarView;
    }

    static create() {
        return new InfoBox();
    }

    getExtensions() {
        return [InfoBoxNode];
    }
}